import defaultRestApi from '../common/config/RestApiInstance'
import APIs from '../common/config/APIs'
import axios from 'axios';
import querystring from 'query-string';

const CancelToken = axios.CancelToken;
let cancel
export default class BetPlacementService {

  static postPlaceBetAPI = (payload, uniqueRequestId) => {
    return defaultRestApi.post(APIs.betPlacementBuyURL(uniqueRequestId),
      payload
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static postPlaceParlayBetAPI = (payload, uniqueRequestId) => {
    return defaultRestApi.post(APIs.placeParlayBetURL(uniqueRequestId),
      payload
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }


  static getAllOddsSelectionInfo = (payload) => {
    return defaultRestApi.post(APIs.allOddsSelectionsURL(),
      payload
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static updateAllOddsSelectionsInfo = (selectionsData) => {
    return defaultRestApi.post(APIs.oddsSelectionsUpdateURL(),
      selectionsData
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static getCorrelatedSelection = (payload) => {
    return defaultRestApi.post(APIs.correlateSelectionsURL(),
      payload
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static getParlayOddsSelection = (payload) => {
    return defaultRestApi.post(APIs.parlayOddsSelectionsURL(),
      payload
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static getTeaserOddsSelection = (params) => {
    return defaultRestApi.get(APIs.getTeaserTicketURL(params));
  }

  static removeTeaserTicket = (params) => {
    return defaultRestApi.get(APIs.removeTeaserTicketURL(params));
  }

  static buyTeaserBetURL = (payload, uniqueRequestId) => {
    return defaultRestApi.post(APIs.buyTeaserBetURL(uniqueRequestId),
      payload
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static updateTeaserTicket = (params) => {
    return defaultRestApi.get(APIs.updateTeaserTicket(params));
  }

  static getParlayUpdateOddsSelection = (payload) => {
    return defaultRestApi.post(APIs.parlayUpdateOddsURL(),
      payload
      , {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static removeParlayBetSelection = (payload, legId) => {
    return defaultRestApi.post(APIs.parlayRemoveSelectionsURL(legId),
      payload,
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  static updatePitcherParlayTicket = (params) => {
    return defaultRestApi.get(APIs.updatePitcherParlayURL(params));
  }

  static callMyBets = () => {
    return defaultRestApi.get(APIs.mybetURL());
  }

  static getAsiaSingleOdds = (params) => {
    if (cancel) {
      cancel();
    }
    return defaultRestApi.get(APIs.getAsiaSingleOdds(querystring.stringify(params)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
    });
  }

  static getAsiaOutrightOdds = (params) => {
    if (cancel) {
      cancel();
    }
    return defaultRestApi.get(APIs.getAsiaOutrightOdds(querystring.stringify(params)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c;
      })
    }).catch(err => {
    });
  }

  static getParlayUpdateTicket = (params) => {
    if (cancel) {
      cancel()
    }

    return defaultRestApi.get(APIs.updateParlayTicketURL(querystring.stringify(params)), {
      cancelToken: new CancelToken(function executer(c) {
        cancel = c
      })
    }).catch(err => {
      
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/services/BetPlacementService.js